import { _ as I } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.filter-4e9c9996.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.trim-6e13db75.js";
import { c as g } from "./index-8b07dec9.js";
import { useMemo as y } from "react";
import n, { css as s } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import { _ as w } from "./cloneSlots-622cf8c9.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as N } from "./getMetrics-953aa4f8.js";
import { i as C } from "./isClient-2f5bedbd.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as e } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { Divider as b } from "./divider.js";
import { Text as T } from "./text.js";
import { ShareIcon as x, CopyLink as j } from "./shareIcons.js";
import { jsxs as D, jsx as p } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-iteration-759bfbfa.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./string-trim-14e37ad3.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-apply-4756dee6.js";
import "./es.array.is-array-7a29277f.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useClient.js";
import "./popupTip-06ee114c.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./aria.js";
import "./useWindowSize.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./index-5d0f31c6.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.from-fe752fa6.js";
import "./es.array.index-of-084b82ab.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./iconButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./string-html-forced-a746405b.js";
import "./es.date.to-string-6ed49878.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.search-d27ec57a.js";
import "./is-pure-c0f11fe0.js";
import "./safe-get-built-in-a8d8c20c.js";
import "./array-sort-7c90b530.js";
import "./tooltip.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./uniqueId.js";
import "./es.global-this-a7f40ce1.js";
var F = ["title", "pageUrl", "target", "children", "className"], U = /* @__PURE__ */ n.div.withConfig({
  displayName: "shareLinks__StyledShareLinks",
  componentId: "sc-1ukd6w2-0"
})(["&.ShareLinks{", ";}"], function(t) {
  var r = t.theme.components.shareLinks;
  return s(r.ShareLinks);
}), M = /* @__PURE__ */ n(b).withConfig({
  displayName: "shareLinks__StyledDivider",
  componentId: "sc-1ukd6w2-1"
})(["&.ShareLinks__divider{", ";}"], function(t) {
  var r = t.theme.components.shareLinks;
  return s(r.Divider);
}), P = /* @__PURE__ */ n.nav.withConfig({
  displayName: "shareLinks__Links",
  componentId: "sc-1ukd6w2-2"
})(["&.ShareLinks__links{", ";}"], function(t) {
  var r = t.theme.components.shareLinks;
  return s(r.Links);
}), o = function(r) {
  var a = r.title, m = a === void 0 ? "" : a, c = r.pageUrl, l = c === void 0 ? C ? window.location.href : void 0 : c, h = r.target, k = h === void 0 ? "_blank" : h, L = r.children, S = r.className, v = I(r, F), u = N({
    label: "ShareLinks"
  }), i = e(L, {
    Facebook: o.ShareIcon.Facebook,
    LinkedIn: o.ShareIcon.LinkedIn,
    Twitter: o.ShareIcon.Twitter,
    CopyLink: o.CopyLink
  }, e.PickType.LAST), d = e(i.rest, {
    ShareIcons: o.ShareIcon
  }), f = y(function() {
    return w([i.Facebook, i.LinkedIn, i.Twitter].concat(d.ShareIcons, [i.CopyLink]).filter(Boolean), function($, _) {
      return {
        key: _,
        pageUrl: l,
        target: k
      };
    });
  }, [i.Facebook, i.LinkedIn, i.Twitter, i.CopyLink, d.ShareIcons, l, k]);
  return /* @__PURE__ */ D(U, Object.assign({}, u, v, {
    className: g(["ShareLinks", S]),
    children: [(m == null ? void 0 : m.trim().length) > 0 && /* @__PURE__ */ p(T, {
      size: "medium",
      fontWeight: "semi-bold",
      className: "ShareLinks__title",
      children: m
    }), (m == null ? void 0 : m.trim().length) > 0 && /* @__PURE__ */ p(M, {
      className: "ShareLinks__divider"
    }), /* @__PURE__ */ p(P, {
      className: "ShareLinks__links",
      children: f
    })]
  }));
};
o.ShareIcon = x;
o.CopyLink = j;
export {
  o as ShareLinks
};
